import React from "react";
import AmCharts from "@amcharts/amcharts3-react";

const DrivingEventChart = ({ data, lang }) => {
  let dataProvider = [];

  // We can filter the type of events we actually want to display here

  // Right now it will display any and all events
  for (var drivingEvent in data) {
    const eventName = lang["Event" + drivingEvent];
    const occurrance = data[drivingEvent];

    const dataEntry = {
      drivingEvent: eventName,
      occurrence: occurrance
    };

    dataProvider.push(dataEntry);
  }

  let config = {
    type: "pie",
    language: lang._code,
    addClassNames: true,
    pathToImages: "https://cdn.amcharts.com/lib/3/images/",
    categoryField: "drivingEvent",
    theme: "light",
    startDuration: 0,
    angle: 0,
    balloonText:
      "[[title]]<br><span style='font-size:14px'><b>[[value]]</b> ([[percents]]%)</span>",
    labelRadius: 10,
    labelText: "[[value]] pts, [[percents]]%",
    labelTickColor: "#ffffff",
    titleField: "drivingEvent",
    valueField: "occurrence",
    backgroundColor: "#242424",
    outlineThickness: 0,
    allLabels: [],
    labelsEnabled: false,
    autoMargins: false,
    marginTop: 20,
    marginBottom: 20,
    marginLeft: 20,
    marginRight: 20,
    pullOutRadius: 0,
    balloon: {
      fixedPosition: true,
      offsetX: 2,
      offsetY: 5,
      drop: false
    },
    numberFormatter: {
      precision: -1,
      thousandsSeparator: ",",
      decimalSeparator: "."
    },
    legend: {
      enabled: true,
      maxColumns: 1,
      markerType: "circle",
      position: "left",
      align: "center",
      autoMargins: false,
      marginTop: 0,
      marginLeft: 20,
      markerSize: 8,
      valueWidth: 40, //5
      width: 180,
      labelWidth: 80 //55
    },
    colors: ["#AD1E23", "#F04F41", "#F47C20", "#F0F1E5", "#47BD99", "#4767B0"],
    dataProvider: dataProvider,
    responsive: {
      enabled: true,
      addDefaultRules: false,
      rules: [
        // at 400px wide, we hide legend
        {
          maxWidth: 400,
          overrides: {
            autoMargins: false,
            marginTop: 20,
            marginBottom: 0,
            marginLeft: 0,
            marginRight: 0,
            legend: {
              enabled: true,
              maxColumns: 2,
              markerType: "circle",
              position: "bottom",
              align: "center",
              autoMargins: false,
              marginTop: 0,
              marginLeft: 0,
              markerSize: 8,
              valueWidth: 20,
              width: "100%",
              labelWidth: 200
            }
          }
        }
      ]
    }
  };

  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        maxWidth: "500px"
      }}
    >
      <AmCharts.React
        style={{
          width: "100%",
          height: "100%"
        }}
        options={config}
      />
    </div>
  );
};

export default DrivingEventChart;



// WEBPACK FOOTER //
// ./src/charts/DrivingEventChart/DrivingEventsAmcharts.js